const setThreads = (payload) => {
  return {
    type: 'pieveSetThreads',
    payload
  };
};

export default setThreads;
